import { render } from "./BCPChannels.vue?vue&type=template&id=73359ba6"
import script from "./BCPChannels.vue?vue&type=script&lang=js"
export * from "./BCPChannels.vue?vue&type=script&lang=js"

import "./BCPChannels.vue?vue&type=style&index=0&id=73359ba6&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__